// Cart drawer extras mirroring the reference cart: 10-minute expiry timer
// (reset on every cart change, cart cleared when it ends) and colour swap per line.
(() => {
  if (window.__pwCartDrawer) return;
  window.__pwCartDrawer = true;

  const MINUTES = 10;
  const KEY = 'pw_cart_expires_at';
  const root = window.Shopify?.routes?.root || '/';
  const store = {
    get() { try { return Number(localStorage.getItem(KEY)) || 0; } catch (_) { return 0; } },
    set(v) { try { localStorage.setItem(KEY, String(v)); } catch (_) {} },
    clear() { try { localStorage.removeItem(KEY); } catch (_) {} },
  };

  let itemCount = null;
  let clearing = false;

  const timerBox = () => document.querySelector('[data-pw-cart-timer]');

  const resetTimer = () => store.set(Date.now() + MINUTES * 60000);

  const render = () => {
    const box = timerBox();
    if (!box) return;
    if (itemCount === null) itemCount = Number(box.dataset.count || 0);
    if (!itemCount) {
      box.hidden = true;
      store.clear();
      return;
    }
    let ends = store.get();
    if (!ends) { resetTimer(); ends = store.get(); }
    const left = Math.max(0, ends - Date.now());
    const m = Math.floor(left / 60000);
    const s = Math.floor((left % 60000) / 1000);
    box.hidden = false;
    const out = box.querySelector('[data-pw-timer]');
    if (out) out.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    if (left === 0 && !clearing) expire();
  };

  const expire = async () => {
    clearing = true;
    store.clear();
    try { await fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }); } catch (_) {}
    location.reload();
  };

  const refreshCount = async () => {
    try {
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      itemCount = cart.item_count;
    } catch (_) {}
    render();
  };

  // Kaching deal lines: indent the upsell lines (↳) and show the deal name on the main line.
  // Kaching stores its data in a private "__kaching_bundles" property, readable only via cart.js.
  const TAG_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill="currentColor" d="M1 2.5A1.5 1.5 0 0 1 2.5 1h4.38a1.5 1.5 0 0 1 1.06.44l6.62 6.62a1.5 1.5 0 0 1 0 2.12l-4.38 4.38a1.5 1.5 0 0 1-2.12 0L1.44 7.94A1.5 1.5 0 0 1 1 6.88V2.5ZM4.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/></svg>';
  let lastCart = null;
  let decorating = false;
  const decorate = async (refetch) => {
    // The reference shows the discount code field open; Horizon's accordion collapses it on load.
    document.querySelectorAll('#cart-drawer details').forEach((det) => {
      if (det.querySelector('.cart-discount__summary') && !det.open) det.open = true;
    });
    const rows = document.querySelectorAll('#cart-drawer tr[data-key]');
    if (!rows.length || decorating) return;
    decorating = true;
    try {
      if (refetch || !lastCart) lastCart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const info = {};
      const groupTitle = {};
      lastCart.items.forEach((item) => {
        let kc = null;
        try { kc = JSON.parse(item.properties?.__kaching_bundles || 'null'); } catch (_) {}
        info[item.key] = kc;
        if (kc?.id && item.discounts?.length && !groupTitle[kc.id]) groupTitle[kc.id] = item.discounts[0].title;
      });
      rows.forEach((row) => {
        const kc = info[row.dataset.key];
        const upsell = !!kc?.upsell;
        row.classList.toggle('pw-kc-upsell', upsell);
        if (upsell) return;
        const title = kc?.id && groupTitle[kc.id];
        if (!title || row.querySelector('.pw-line-tags')) return;
        const anchor = row.querySelector('.cart-items__title-row');
        if (!anchor) return;
        const tags = document.createElement('div');
        tags.className = 'pw-line-tags';
        const tag = document.createElement('span');
        tag.className = 'pw-tag';
        tag.innerHTML = TAG_SVG;
        tag.append(document.createTextNode(title));
        tags.append(tag);
        anchor.after(tags);
      });
      // Keep each upsell line right below its deal's main line (a colour swap re-adds it at the top).
      const mainRow = {};
      rows.forEach((row) => { const kc = info[row.dataset.key]; if (kc?.main && kc.id) mainRow[kc.id] = row; });
      rows.forEach((row) => {
        const kc = info[row.dataset.key];
        const main = kc?.upsell && mainRow[kc.id];
        if (!main || main.parentNode !== row.parentNode) return;
        let last = main;
        while (last.nextElementSibling?.classList.contains('pw-kc-upsell') && last.nextElementSibling !== row) last = last.nextElementSibling;
        if (last.nextElementSibling !== row) last.after(row);
      });
    } catch (_) {
    } finally {
      decorating = false;
    }
  };
  const drawerObserver = new MutationObserver(() => { clearTimeout(drawerObserver.t); drawerObserver.t = setTimeout(() => decorate(false), 80); });
  const watchDrawer = () => {
    const drawer = document.querySelector('#cart-drawer');
    if (drawer) drawerObserver.observe(drawer, { childList: true, subtree: true });
    decorate(true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();

  const onCartChanged = () => { resetTimer(); setTimeout(refreshCount, 600); setTimeout(() => decorate(true), 700); setTimeout(() => decorate(true), 1600); };

  import('@shopify/events').then((events) => {
    document.addEventListener(events.StandardEvents.cartLinesUpdate, onCartChanged);
  }).catch(() => {});

  setInterval(render, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();

  // Colour swap: remove the line and add the chosen variant with the same quantity and properties.
  document.addEventListener('change', async (event) => {
    const select = event.target.closest('select[data-pw-swap]');
    if (!select) return;
    select.disabled = true;
    const sections = [...document.querySelectorAll('cart-items-component')].map((n) => n.dataset.sectionId).filter(Boolean).join(',');
    // Private properties (e.g. Kaching's "__kaching_bundles") only exist in cart.js, not in Liquid.
    let props = {};
    let qty = Number(select.dataset.qty) || 1;
    try {
      const current = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const line = current.items.find((item) => item.key === select.dataset.key);
      if (line) { props = line.properties || {}; qty = line.quantity; }
    } catch (_) {}
    let events = null;
    try { events = await import('@shopify/events'); } catch (_) {}
    const deferred = events ? events.CartLinesUpdateEvent.createPromise() : null;
    if (events) {
      select.dispatchEvent(new events.CartLinesUpdateEvent({
        action: 'update', context: 'cart',
        lines: [{ merchandiseId: select.value, quantity: qty }], promise: deferred.promise,
      }));
    }
    try {
      const removed = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: select.dataset.key, quantity: 0 }),
      });
      if (!removed.ok) throw new Error('remove failed');
      const added = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(select.value), quantity: qty, properties: props }], sections }),
      });
      const result = await added.json();
      if (!added.ok || result.status) throw new Error(result.description || 'add failed');
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (deferred) {
        deferred.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'pw-cart-drawer', sections: result.sections, didError: false } });
      } else {
        location.reload();
      }
    } catch (error) {
      if (deferred) deferred.reject(error);
      location.reload();
    }
  });
})();
